module.exports = __webpack_public_path__ + "static/img/10.14b9345.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/10.png
// module id = jhls
// module chunks = 0